import React from 'react';

const ChatIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9652 3C12.9652 1.89543 12.0698 1 10.9652 1H3C1.89543 1 1 1.89543 1 3V12.9652L4.73913 9.97391H9.97391C11.6191 9.97391 12.9652 8.62783 12.9652 6.98261V3Z"
      stroke="#555B67"
      strokeWidth="2"
    />
    <path
      d="M6.23486 9.97399V12.2175C6.23486 13.8627 7.58095 15.2088 9.22617 15.2088H14.461L18.2001 18.2001V8.23486C18.2001 7.1303 17.3047 6.23486 16.2001 6.23486H12.9653"
      stroke="#555B67"
      strokeWidth="2"
    />
  </svg>
);

export default ChatIcon;
